import React, {useState, useEffect, useRef, useCallback} from 'react';

import Avatar from 'components/Avatar';
import IfRender from 'components/IfRender';
import Pager, {usePager} from 'components/Pager';
import CommentItem from './components/CommentItem';
import { YDLog } from 'components/YDLog'
import Emoji from 'components/Emoji'

import {UserData} from 'fetch';

import {COMMENT, ICommentItem} from 'fetch/works';
import redirectLogin from 'fetch/redirectLogin'

import {MAX_LENGTH} from '../constants';
import {defaultAvatar} from 'assets';
import CommentContext from './store';

import { showToast } from '@turingshequ/react-toast/src';
import {num2likestr} from 'util/index';
import s from './index.module.scss';

interface Props {
  user: UserData | undefined | null
  workId: string
  authorId: string
  onReport: (data?:any) => void
}
const PAGE_SIZE = 10;

const Comment: React.FC<Props> = ({
  user, workId, authorId, onReport
}) => {

  const [inputText, setInputText] = useState('');
  const [inputTextNum, setInputTextNum] = useState(0);
  const [commentList, setCommentList] = useState([] as ICommentItem[]);
  const [totalNum, setTotalNum] = useState(0);

  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const isInitData = useRef(false);

  const {
    currentPage,
    totalPage,
    setCurrentPage,
    setTotal
  } = usePager()

  const fetchFn = useCallback(
    (workId, currentPage) => {
      COMMENT.get({id: workId, page: currentPage, size: PAGE_SIZE})
      .then(({dataList, totalCount}) => {
        setCommentList(dataList)
        setTotalNum(totalCount);
        setTotal((totalCount||0) / PAGE_SIZE)
        isInitData.current = false;
      })
      .catch((err) => {
        console.log('评论列表获取出错', err)
        isInitData.current = false;
      })
    },
    [workId, currentPage],
  )

  const initData = useCallback(
    () => {
      isInitData.current = true;
      fetchFn(workId, 1)
      setCurrentPage(1);
      setInputTextNum(0);
    },
    [workId],
  )

  useEffect(() => {
    if(isInitData.current) {
      return;
    }
    fetchFn(workId, currentPage);
  }, [currentPage])

  useEffect(() => {
    initData();
  }, [workId])

  const onChange = (e: any) => {
    const text = e?.target?.value || '';
    setInputText(text)
    setInputTextNum(text.length);
  }
  /**
   * 作品评论
   */
  const handleComment = () => {

    if(!user) {
      redirectLogin();
      return;
    }

    if(!inputText.trim()) {
      showToast({
        type: 'default',
        message: '请检查输入内容~'
      })
      return;
    }

    COMMENT.post({
      id: workId,
      content: inputText
    }).then((res: any) => {
      if(textAreaRef.current) {
        textAreaRef.current.value = '';
      }
      const message = res?.code === 0 ? '评论成功~' : res?.description;
      showToast({
        type: 'default',
        message
      })
      initData()
    }).catch((err) => {
      console.log('评论失败', err)
    })
  }

  const handleInsertEmoji = (name: string) => {
    const nameLength = name.length + 2;
    if(inputTextNum +  nameLength > 200) {
      return;
    }
    const textArea = textAreaRef.current;
    const emojiText = `[${name}]`;
    textArea?.focus();
    textArea?.setRangeText(emojiText, textArea?.selectionStart, textArea?.selectionEnd, "end");
    textArea?.blur();
    onChange({
      target: {
        value: textAreaRef?.current?.value
      }
    })
  }

  const handleFormInputKeydown = (event: any) => {
    const textArea = textAreaRef.current;
    const chatString = textArea?.value || '';

    if (event.keyCode === 8 && textArea?.selectionStart === textArea?.selectionEnd) {
        const indexEnd = (textArea?.selectionStart || 0) - 1;
        const charToDelete = chatString?.charAt(indexEnd);
        if (charToDelete === "]") {
            event.preventDefault();
            const indexStart = chatString.lastIndexOf("[", indexEnd);
            textArea?.setRangeText("", indexStart, indexEnd + 1, "end");
            onChange({
              target: {
                value: textAreaRef?.current?.value
              }
            })
        }
    }
  }

  const isAuthor = authorId === user?.userId;

  return (
    <CommentContext.Provider value={{isAuthor, onReport}}>
    <div className={s.wrap}>
      <div className={s.title}>评论 ({num2likestr(totalNum)})</div>
      {/* 评论作品的输入框 */}
        <div className={s.handleWrap}>
          <div className={s.inputWrap}>
            <IfRender show={!!user}>
              <Avatar size={56} url={user ? user.userImage : ''} />
            </IfRender>
            <IfRender show={!user}>
              <div onClick={redirectLogin}>
                <Avatar size={56} url={defaultAvatar} />
              </div>
            </IfRender>
            <textarea
              ref={textAreaRef}
              onChange={onChange}
              className={s.commentInput}
              placeholder="作品有哪些值得鼓励或改进的地方呢？记得保持友善、礼貌 相互鼓励，相互进步哦！～"
              maxLength={MAX_LENGTH}
              onKeyDown={handleFormInputKeydown}
            />
            <div className={s.number}>
              <span style={{color: inputTextNum === 200 ? 'red': ''}}>{inputTextNum}</span>/{MAX_LENGTH}
            </div>
          </div>
          <div className={s.buttonWrap}>
            <Emoji onClick={handleInsertEmoji}/>
            <YDLog click={{ name: 'click', data: { button_name: '评论' } }}>
            <div className={s.button} onClick={handleComment}>评论</div>
            </YDLog>
          </div>
        </div>
      {/* 评论列表 */}
      <div className={s.commentList}>
        {
          commentList.map(comment => (
            <CommentItem
              comment={comment}
              key={comment.id}
              onDelete={initData}
            />
          ))
        }
      </div>
      {/* 评论列表的分页 */}
      <IfRender show={!!(totalNum>PAGE_SIZE)}>
        <div style={{marginBottom: '20px'}}>
          <Pager
            current={currentPage}
            total={totalPage || 1}
            onChange={(val) => setCurrentPage(val)}
            buttonSize={5}
          />
        </div>
      </IfRender>
    </div>
    </CommentContext.Provider>
  )
}
export default Comment;

